import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchPermissions, deletePermission } from "actions/permission";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import SearchForm from "./SearchForm";
import Table from "./Table";
import Pagination from "components/Pagination";

class PermissionIndex extends Component {
  componentDidMount() {
    this.props.fetchPermissions();

    this.search = {};
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.props.fetchPermissions({ ...this.search });
  };

  onPaginationClick = page => event => {
    const { permissionURL: permission_url } = this.props.match.params;
    this.props.fetchPermissions({ permission_url, page, ...this.search });
  };

  handlePermissionDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        this.deletePermissionProcess(id);
      },
      title: "Delete permission",
      body: "Are you sure you want to delete this permission?"
    });
  };

  deletePermissionProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deletePermission, match } = this.props;
    const { permissionURL: permission_url } = match.params;
    deletePermission(id, { permission_url })
      .then(() => {
        this.props.fetchPermissions({ ...this.search });
        toggleNotification(true, { infoClassName: "is-success", message: "Delete Permission Success" });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const { permissions } = this.props;

    return (
      <div>
        <div className="box">
          <SearchForm onSearchFormSubmit={this.onSearchFormSubmit} />
          <Table permissions={permissions} onClickDelete={this.handlePermissionDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={permissions.current_page}
            lastPage={permissions.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authPermission, permissions, confirmationPopupActive }) => ({
  authPermission,
  permissions,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchPermissions, deletePermission, toggleconfirmationPopup, toggleNotification }
)(PermissionIndex);



// WEBPACK FOOTER //
// ./src/pages/Permission/Index/index.js